export const USER_TYPE = {
    EMPLOYEE: 'EMPLOYEE'
}